import Raven from 'raven-js';
import getLang from 'I18n/utils/getLang';
import { getCategoriesByApiNamesRpc } from '../../../__generated__/chirp/com/hubspot/feature/store/rpc/FeatureCategoriesRpc';
import { rpcClient } from '../../rpcClient';
export const fetchFeatureCategories = ({
  productApiNames
}) => {
  let featureCategories = [];
  let promiseError = undefined;
  return rpcClient.call(getCategoriesByApiNamesRpc, {
    request: {
      apiNames: productApiNames,
      i18nLangLocale: getLang()
    }
  }).then(featureCategoryResponseList => {
    const allFeaturesForRequestedProducts = [];
    for (const category of featureCategoryResponseList.categories) {
      for (const parentFeature of category.features) {
        allFeaturesForRequestedProducts.push(parentFeature.displayName);
        for (const childFeature of parentFeature.childrenFeatures) {
          allFeaturesForRequestedProducts.push(childFeature.displayName);
        }
      }
    }
    if (allFeaturesForRequestedProducts.length < 5) {
      const notEnoughFeaturesError = new Error(`fetchFeatureCategories: Not enough features to display. Expected at least 5 features and received only ${allFeaturesForRequestedProducts.length}`);
      console.error(notEnoughFeaturesError);
      Raven.captureException(notEnoughFeaturesError, {
        extra: {
          productApiNames
        }
      });
      return [];
    }

    // Only display categories that have active features listed within them
    featureCategories = featureCategoryResponseList.categories.filter(category => category.features.length > 0);
  }, error => {
    promiseError = error;
    Raven.captureException(new Error(error.message, {
      cause: error
    }), {
      extra: {
        productApiNames
      }
    });
  }).catch(error => {
    promiseError = error;
    Raven.captureException(new Error('fetchFeatureCategories: Promise successfully resolved but the catch block was triggered', {
      cause: error
    }), {
      extra: {
        productApiNames
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    return featureCategories;
  });
};